import { render, staticRenderFns } from "./naturalSurvey.vue?vue&type=template&id=37c9fab4&scoped=true"
import script from "./naturalSurvey.vue?vue&type=script&lang=js"
export * from "./naturalSurvey.vue?vue&type=script&lang=js"
import style0 from "./naturalSurvey.vue?vue&type=style&index=0&id=37c9fab4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c9fab4",
  null
  
)

export default component.exports